<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <section class="miniStack">
    <p>
      Inline element available everywhere in our app:
      <code>&lt;Badge label="msg" icon="message" /&gt;</code> (
      <Badge label="msg" icon="message" />)
    </p>
    <div>
      <h3>variants</h3>
      <p>
        props: <code>{{ variants.join(', ') }}</code>
      </p>
      <div class="flex items-center gap-2">
        <Badge
          v-for="variant in variants"
          :key="variant"
          :variant="variant"
          :label="variant"
        />
      </div>
    </div>
    <div />
    <div>
      <h3>with icon</h3>
      <p>
        <code>&lt;Badge label="msg" icon="volunteer_activism" /&gt;</code>
      </p>

      <div class="flex items-center gap-2">
        <Badge
          v-for="variant in variants"
          :key="variant"
          icon="volunteer_activism"
          :variant="variant"
          :label="variant"
        />
      </div>
    </div>
    <div />
    <div>
      <h3>icon only</h3>
      <p><code>&lt;Badge icon="volunteer_activism" /&gt;</code></p>
      <div class="flex items-center gap-2">
        <Badge
          v-for="variant in variants"
          :key="variant"
          icon="volunteer_activism"
          :variant="variant"
        />
      </div>
    </div>
    <p />
    <div>
      <h3>Default Slot</h3>
      <p>
        You can pass a children to Badge, it will be rendered as-is<br /><br />
        <code>&lt;Badge&gt;&lt;Badge label="inception"&gt;&lt;/Badge&gt;</code>
      </p>
      <div class="flex items-center gap-2">
        <Badge v-for="variant in variants" :key="variant" :variant="variant">
          <Badge label="inception!" />
        </Badge>
      </div>
      <p>
        <code
          >&lt;Badge icon="check"&gt;&lt;Badge
          icon="check"&gt;&lt;/Badge&gt;</code
        >
      </p>
      <div class="flex items-center gap-2">
        <Badge
          v-for="variant in variants"
          :key="variant"
          :variant="variant"
          icon="check"
        >
          <Badge icon="check" />
        </Badge>
      </div>
    </div>
    <p />
    <div>
      <h3>Examples</h3>
      <p>Badges used in the wild.</p>
      <BaseCard style="max-width: 500px">
        <div class="flex items-center gap-2">
          <strong data-i="business" class="flex-1 before:mr-1"
            >Business Name</strong
          >
          <Badge icon="check" variant="success"> Approved </Badge>
        </div>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </BaseCard>
      <p />
      <div :class="$style.bar">
        <CButton size="sml" class="lock" icon="lock" iconBefore> lock </CButton>
        <div class="flex items-center gap-2">
          <Badge variant="primary" label="Draft" />
          Order DXJXQ5
        </div>
        <CButton size="sml" class="lock" icon="close"> close </CButton>
      </div>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et
        <Badge icon="search"> dolor </Badge> magna aliqua.
      </p>
    </div>

    <CButton
      @click="
        () => {
          $toast.warning('This is a toast message');
          $toast.error('This is a toast message');
        }
      "
    >
      Error
    </CButton>
    <CButton
      @click="
        () => {
          $toast.success('This is a toast message');
        }
      "
    >
      Success
    </CButton>
    <CButton
      @click="
        () => {
          $toast('This is a toast message');
          $toast.info('This is a toast message');
        }
      "
    >
      Info
    </CButton>
  </section>
</template>
<script>
import { variants } from '@/components/elements/Badge.vue';
export default {
  data() {
    return { variants };
  },
};
</script>
<style module>
.bar {
  padding: 0.5rem 1rem;
  background-color: var(--neutral-900);
  color: var(--neutral-200);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
